import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Ban } from "lucide-react";

import { api, photoUri } from "@/lib/api";
import { SAFETY_KEYS } from "@/hooks/use-save-toggle";
import { useToast } from "@/components/toast";
import { BackHeader } from "@/components/back-header";
import { Button, EmptyState, ErrorState, Loading } from "@/components/ui";

export default function BlockedMembers() {
  const toast = useToast();
  const qc = useQueryClient();
  const { data, isLoading, isError, error, refetch } = useQuery({ queryKey: ["blocks"], queryFn: () => api("/blocks") });
  const unblock = async (b) => {
    try {
      await api(`/blocks/${b.member_id}`, { method: "DELETE" });
      toast(`${b.display_name} unblocked`, "success");
      SAFETY_KEYS.forEach((k) => qc.invalidateQueries({ queryKey: [k] }));
    } catch (e) { toast(e.message, "error"); }
  };
  return (
    <div data-testid="blocked-members-screen" className="mx-auto max-w-2xl">
      <BackHeader title="Blocked Members" />
      {isLoading ? <Loading /> : isError ? <ErrorState testId="blocked-error" message={error.message} onRetry={() => refetch()} /> : !data?.blocked.length ? (
        <EmptyState testId="blocked-empty" icon={Ban} title="No blocked members." text="Members you block appear here." />
      ) : (
        <ul className="flex flex-col gap-2">
          {data.blocked.map((b) => (
            <li key={b.member_id} data-testid={`blocked-item-${b.member_id}`} className="flex items-center gap-3 rounded-[20px] border border-border bg-white p-3">
              <img src={photoUri(b.main_photo_url)} alt="" className="h-12 w-12 rounded-full bg-[#F4EBE6] object-cover" />
              <div className="flex-1"><p className="font-bold">{b.display_name}</p><p className="text-xs text-muted-foreground">Blocked {new Date(b.blocked_at).toLocaleDateString()}</p></div>
              <Button testId={`unblock-button-${b.member_id}`} title="Unblock" size="sm" variant="outline" onClick={() => unblock(b)} />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
